import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import localeEn from '@angular/common/locales/en';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes'
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AbstractEndpoint } from './services/abstract-endpoint.service';
import { AbstractService } from './services/abstract.service';
import { AccountEndpoint } from './services/account-endpoint.service';
import { AccountService } from './services/account.service';
import { AlertService } from './services/alert.service';
import { AppTitleService } from './services/app-title.service';
// import { AuthInterceptor } from './services/auth-interceptor'; // Used directly in the routes
import { CodingEndpoint } from './services/coding-endpoint.service';
import { CodingService } from './services/coding.service';
import { ConfigurationService } from './services/configuration.service';
import { EndpointFactory } from './services/endpoint-factory.service';
import { ExcelService } from './services/excel.service';
import { LocalStoreManager } from './services/local-store-manager.service';
import { NoteEndpoint } from './services/note-endpoint.service';
import { NoteService } from './services/note.service';
import { NotificationEndpoint } from './services/notification-endpoint.service';
import { NotificationService } from './services/notification.service';
import { ProtocolEndpoint } from './services/protocol-endpoint.service';
import { ProtocolService } from './services/protocol.service';
import { ReportEndpoint } from './services/report-endpoint.service';
import { ReportService } from './services/report.service';
import { TeamEndpoint } from './services/team-endpoint.service';
import { TeamService } from './services/team.service';
import { authInterceptorFn } from './services/auth-interceptor';
import { provideToastr } from 'ngx-toastr';
import { AuthService } from './services/auth.service';
import { PACTHubService } from './services/pacthub.service';
import { ErrorService } from './services/error.service';
import { KappaService } from './services/kappa.service';

registerLocaleData(localeEn);

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(
            routes,
            withRouterConfig({ onSameUrlNavigation: 'reload' }),
            withComponentInputBinding()
        ), 
        provideHttpClient(
            withInterceptors([authInterceptorFn])
        ),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideAnimations(),
        provideToastr({ 
            positionClass: 'toast-top-right',
            maxOpened: 100,
            closeButton: true,
            //autoDismiss: true,
            timeOut: 50000,
            extendedTimeOut: 1000,
            preventDuplicates: true,
            countDuplicates: true,
            iconClasses: {                             // Custom icon classes
                success: 'toast-success',
                error: 'toast-error',
                info: 'toast-info',
                warning: 'toast-warning'
            },
            newestOnTop: false,
            tapToDismiss: true,
            progressBar: true,
            resetTimeoutOnDuplicate: false,
            includeTitleDuplicates: false,
            disableTimeOut: false,
            progressAnimation: 'increasing',
            enableHtml: true,
            // toastClass: 'toast',
            // titleClass: 'toast-title',
            // messageClass: 'toast-message',
            easing: 'ease-in',
            easeTime: 300,
            onActivateTick: true
         }),
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        { provide: 'BASE_URL', useFactory: getBaseUrl },
        // Services
        AbstractService,
        AccountService,
        AlertService,
        AppTitleService,
        AuthService,
        CodingService,
        ConfigurationService,
        ErrorService,
        ExcelService,      
        KappaService,
        NoteService,
        NotificationService,
        PACTHubService,
        ProtocolService,
        ReportService,
        TeamService,
        AccountEndpoint,
        AbstractEndpoint,
        CodingEndpoint,
        DatePipe,
        EndpointFactory,
        JwtHelperService,
        LocalStoreManager,
        NoteEndpoint,        
        NotificationEndpoint,
        ProtocolEndpoint,
        ReportEndpoint,
        TeamEndpoint,
    ]
}

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}
